import type {AxiosError} from 'axios';
import {useMutation, useQueryClient, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {
	markDeletePaymentWay,
	setPaymentWayPrimary,
	type MarkDeletePaymentWayPath,
	type MarkDeletePaymentWayResponse,
	type SetPaymentWayPrimaryPath,
	type SetPaymentWayPrimaryResponse,
} from '../../http/paymentWays/paymentWayActions';

export function useSetPaymentWayPrimary(
	options?: UseMutationOptions<SetPaymentWayPrimaryResponse, AxiosError, SetPaymentWayPrimaryPath>,
): UseMutationResult<SetPaymentWayPrimaryResponse, AxiosError, SetPaymentWayPrimaryPath> {
	const queryClient = useQueryClient();

	return useMutation<SetPaymentWayPrimaryResponse, AxiosError, SetPaymentWayPrimaryPath>(
		(path) => setPaymentWayPrimary(path).then(({data}) => data),
		{
			...options,
			onSuccess: (data, variables, context) => {
				queryClient.invalidateQueries({queryKey: ['paymentWays']});
				queryClient.invalidateQueries({queryKey: ['paymentWay', variables.type, variables.id]});
				options?.onSuccess?.(data, variables, context);
			},
		},
	);
}

export function useMarkDeletePaymentWay(
	options?: UseMutationOptions<MarkDeletePaymentWayResponse, AxiosError, MarkDeletePaymentWayPath>,
): UseMutationResult<MarkDeletePaymentWayResponse, AxiosError, MarkDeletePaymentWayPath> {
	const queryClient = useQueryClient();

	return useMutation<MarkDeletePaymentWayResponse, AxiosError, MarkDeletePaymentWayPath>(
		(path) => markDeletePaymentWay(path).then(({data}) => data),
		{
			...options,
			onSuccess: (data, variables, context) => {
				queryClient.invalidateQueries({queryKey: ['paymentWays']});
				queryClient.invalidateQueries({queryKey: ['paymentWay', variables.type, variables.id]});
				options?.onSuccess?.(data, variables, context);
			},
		},
	);
}
